export default {
    props: {
        value: {
            type: Number | Array,
            default: () => null | [],
        }
    },
    methods: {
        isActive(option) {
            return this.value === option;
        },
        handleCheck(option) {
            const index = this.value.indexOf(option);
            if (index === -1) {
                this.$emit('input', [...this.value, option]);
            } else {
                const newValue = Array.from(this.value);
                newValue.splice(index, 1);
                this.$emit('input', newValue);
            }
            this.$emit('change');
        },
        handleClick(option) {
            this.$emit('input', option);
            this.$emit('change');
        }
    }
};
